// extracted by mini-css-extract-plugin
export default {"Wrapper":"FinancialsIngestionNote_Wrapper__x15hu","Label":"FinancialsIngestionNote_Label__7-T4B"};